export enum ApiRoutesWarehouses {
  Warehouses = "warehouse-admin",
}
